import { AppUtil, EnvUtil, IReport } from 'kuaidong-lib'
import { UserInfo, UserTeacherId, UserRoleInfo } from 'kuaidong-model'

export class AUser {
  public static async loginByH5Token(): Promise<UserTeacherId> {
    if (EnvUtil.isAgency()) {
      return AppUtil.httpGET('/tr/coach/user/login_by_h5token')
    }
    if (EnvUtil.isOperation()) {
      return {}
    }
    return AppUtil.httpGET('/account/login_by_h5token', {}, {}, true)
  }

  /**
   * 判断是否是多孩账户下的子账户
   * @returns {boolean} 是否为子账号
   */
  public static async checkIsSubAccount(): Promise<boolean> {
    const resp = await AppUtil.httpGET('/account/login_sub_account')
    return resp.is_sub_account
  }

  public static async getUserInfo(): Promise<UserInfo> {
    return AppUtil.httpGET('/account/user_info')
  }

  public static async feedback(feedback: { message: string; rate: number }): Promise<void> {
    return AppUtil.httpPOST('/user/feedback', feedback)
  }

  public static async getDrillReport(drill_record_id: string): Promise<IReport> {
    return AppUtil.httpGET(
      process.env.VUE_APP_CRAZYROPE_API + '/user/drill_report_info',
      { drill_record_id },
      {},
      false,
      false
    )
  }

  public static async getRoleInfo(): Promise<UserRoleInfo> {
    return AppUtil.httpGET('/account/role_info')
  }
}
